<template>
  <tr v-if="theOrder.id" class="product">
    <td class="small-cell">{{ theOrder.id }}</td>
    <td class="small-cell">{{ theOrder.seller_name }}</td>
    <td class="mid-cell adress">
      <p>{{ theOrder.address }}</p>
    </td>
    <td class="small-cell">{{ theOrder.user_phone }}</td>
    <td class="small-cell">{{ theDate }}</td>
    <td class="small-cell">{{ theOrder.delivery_cost }}</td>
    <td class="small-cell">{{ theOrder.payable }}</td>
    <td class="px-0">{{ theOrder.discount_code }}</td>
    <td class="small-cell">
      <Etiquette :status="parseInt(theOrder.status)"></Etiquette>
    </td>
    <td class=" textarea">
      <textarea
        @focus="show_submit(theOrder.id)"
        @blur="hide_submit()"
        v-model="theOrder.admin_comment"
        class="description"
        rows="3"
      ></textarea>
      <div v-if="theOrder.id == show_my_submit" class="text-center px-2">
        <button
          @click="submit_description(theOrder)"
          class="submit-description"
        >
          ثبت
        </button>
      </div>
    </td>
    <td class="">
      <!-- <button @click="reviseOrder" class="purple-btn ml-2">ثبت وضعیت</button> -->
      <custom-input
        placeholder="انتخاب وضعیت"
        inputClass="tNormal"
        labelClass="tLighter"
        kind="dropDown"
        container=""
        v-bind:theModel.sync="status"
        :selectItems="stati"
        classes="no-border light-facade"
        @newSelect="choice_status"
      ></custom-input>
    </td>
    <td class="small-cell">
      <button class="btn-primary rounded px-2 py-2" @click="see_order(theOrder)">مشاهده</button>
    </td>
  </tr>
</template>
<script>
import { ref } from "@vue/composition-api";
import Etiquette from "./etiquette";
import CustomInput from "../../../Common/CustomInput";
import jalalim from "jalali-moment";
import Service from '../../../../utils/admin-service'

export default {
  props: ["theOrder"],
  components: {
    Etiquette,
    CustomInput,
  },
  data: () => ({
    fromChild: null,
    status: { value: null, valid: true },
    stati: [
      { value: 1, text: "پرداخت شده" },
      { value: 2, text: "قبول شده" },
      { value: 3, text: "رد شده" },
      { value: 4, text: "در حال آماده سازی" },
      { value: 5, text: "در حال ارسال" },
      { value: 6, text: "تحویل داده شده" },
    ],
    show_my_submit: null,
  }),
  methods: {
    choice_status(option) {
      let formData = new FormData();
      formData.append("status", option.value);
      this.theService.transmit(
        "admin/order/" + this.theOrder.id,
        formData,
        (s, d) => {
          alert("تغییر وضعیت انجام شد");
        },
        (s, e) => {}
      );
    },
    // reviseOrder: function () {
    //   this.$emit("reviseOrder", {
    //     id: this.theOrder.id,
    //     status: this.status.value.value,
    //   });
    // },
    submit_description(theOrder) {
      this.$emit("submit_description", {
        id: theOrder.id,
        description: theOrder.admin_comment,
      });
    },
    see_order(this_order) {
      this.$emit("see_order", this_order);
    },
    show_submit: function (me) {
      this.show_my_submit = me;
    },
    hide_submit: function () {
      setTimeout(() => {
        this.show_my_submit = 0;
      }, 300);
    },
  },
  watch: {
    status: function (val) {
      console.log("this changed");
    },
  },
  computed: {
    theDate: function () {
      return jalalim(this.theOrder.pay_time).locale("fa").format("YY/MM/DD");
    },
    theService(){
      return Service(false);
    }
  },
};
</script>
<style lang="scss" scoped>
td {
  border: 1px solid rgba(127, 127, 127, 0.2);
  white-space: nowrap;
  padding: 0.5rem;
}

tr {
  width: 100%;
}

.order-locker img {
  width: 50%;
}

.small-cell {
  width: 5%;
  &.micro{
    width: 3%;
  }
}

.mid-cell {
  width: 10%;
}

.mid-cell p {
  white-space: pre-wrap;
  overflow: hidden;
}

.large-cell {
  width: 23%;
  &.textarea {
    padding: 0;
  }
  textarea {
    width: 100%;
    outline: none;
    font-size: 11px;
  }
}
.submit-description {
  padding: 5px;
  border-radius: 5px;
  color: #fff;
  outline: none;
  width: 100%;
  margin-top: 15px;
  background: #0a77cd;
  // border: solid 2px #b0d6f3;
  margin-bottom: 3px;

  &:hover {
    background: #2196f3;
    color: white;
  }
}
</style>